import { render } from "./Title2.vue?vue&type=template&id=1137af73"
import script from "./Title2.vue?vue&type=script&lang=ts"
export * from "./Title2.vue?vue&type=script&lang=ts"

import "./Title2.vue?vue&type=style&index=0&id=1137af73&lang=scss"
script.render = render

export default script